import logo from './logo.svg';
import './App.css';
import App1 from './MainInterface.jsx';
import MainLayout from './MainLayout';
function App() {
  return (
    <div className="App">
      <MainLayout/>
    </div>
  );
}

export default App;
